import * as React from "react";
import { EditorTools, EditorToolsSettings } from "@progress/kendo-react-editor";

const CustomFormatBlock = EditorTools.createFormatBlockDropDownList(EditorToolsSettings.formatBlock);
/**
 * Format block dropdown (paragraph, headings) for the DOX editor toolbar.
 * @author Abhishek Dhillon
 */
const CustomFormatBlockTool = (props) => (
  <span className='custom-format-block-tool-wrap'>
    <CustomFormatBlock
      {...props}
      style={{
        width: "120px",
        ...props.style,
      }}
      popupSettings={{
        width: "210px",
        ...props.popupSettings,
      }}
    />
  </span>
);

export { CustomFormatBlockTool };
